import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ENDPOINTS, axiosInstance } from "../../Api/apiConfig";
import "../../Styling/NewLoadOrAgent.css";

const SignupBroker = ({ onSaveSuccess, userRole }) => {
  const { register, handleSubmit, reset } = useForm();
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);

  const onSubmit = async (data) => {
    if (isRequestInProgress) {
      return;
    }
    setIsRequestInProgress(true);

    let id = toast.loading("Broker is being added. Please Wait..."); // Update id inside the try block
    try {
      const formData = new FormData();
      Object.keys(data).forEach((val) => {
        formData.append(val, data[val]);
      });

      await axiosInstance.post(API_ENDPOINTS.BROKERS, formData);
      toast.update(id, {
        render: "Successful. New broker is added.",
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
      reset();
      onSaveSuccess();
      document.getElementById("closeButtonSignUpBroker").click();
    } catch (error) {
      toast.update(id, {
        render: error.response.data.message,
        type: "error",
        isLoading: false,
        autoClose: 1500,
      });
      console.error("Error ocurred while adding new broker:", error);
    } finally {
      setIsRequestInProgress(false);
    }
  };

  return (
    <div
      className="modal fade"
      id="modalNewBroker"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fw-bold fs-5">Broker Registration</h1>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="modal-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">Name:</label>
                <input
                  type="text"
                  className="form-control create-input"
                  {...register("brokerName", {
                    required: true,
                    maxLength: 255,
                  })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">MC#</label>
                <input
                  type="text"
                  className="form-control create-input"
                  {...register("mcNumber", { maxLength: 255 })}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">Phone:</label>
                <input
                  type="text"
                  className="form-control create-input"
                  {...register("brokerPhone", {
                    maxLength: 255,
                  })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">After Hours:</label>
                <input
                  type="text"
                  className="form-control create-input"
                  {...register("brokerAfterHours", { maxLength: 255 })}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">Email:</label>
                <input
                  type="email"
                  className="form-control create-input"
                  {...register("brokerEmail", { maxLength: 255 })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Status:</label>
                <select
                  className="form-control create-input"
                  {...register("brokerStatus")}
                >
                  <option value="Active" selected>
                    Active
                  </option>
                  <option value="Disabled">Disabled</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Invoice Submitted Thru:
                </label>
                <select
                  className="form-control create-input"
                  {...register("invoiceSubmittedThru")}
                >
                  <option value="Email" selected>
                    Email
                  </option>
                  <option value="Epay">Epay</option>
                  <option value="Triumphpay">Triumphpay</option>
                  <option value="Portal">Portal</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Payment Method:</label>
                <select
                  className="form-control create-input"
                  {...register("invoiceMethodPaid")}
                >
                  <option value="ACH" selected>
                    ACH
                  </option>
                  <option value="Check">Check</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-12">
                <label className="form-label fw-bold">Billing Email:</label>
                <input
                  type="email"
                  className="form-control create-input"
                  {...register("brokerBillingEmail", { maxLength: 255 })}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-12">
                <label className="form-label fw-bold">Broker Notes:</label>
                <input
                  type="text"
                  className="form-control create-input"
                  {...register("brokerNotes", {})}
                />
              </div>
            </div>

            <div>
              <button type="submit" className="btn reg-user-submit">
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                id="closeButtonSignUpBroker"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignupBroker;
